import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Tabs from '../../../../../Components/Tabs';
import ToDoListCompletedItems from './ToDoListCompletedItems';
import ToDoListActiveItems from './ToDoListActiveItems';
import ToDoListController from '../../../../Controllers/AdminScreens/AddOns/ToDoList/ToDoListController';

const ToDoListScreen = () => {

    const { state } = useLocation();
    const [selectedTab, setSelectedTab] = useState(state?.selectedTab || 0);

    const{

        completedToDoList,
        completedToDoError,
        completedToDoLoading,
        setCompletedToDoLoading,
        setCompletedToDoError,
        setCompletedToDoList,

        activeToDoList,
        activeToDoError,
        activeToDoLoading,
        setActiveToDoLoading,
        setActiveToDoError,
        setActiveToDoList,

        fetchExpiredToDoItemsList,
        fetchActiveToDoItemsList
    }= ToDoListController();

    // useEffect(() => {
    //     const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_') || '{}');
    //     const { per_name_sub_json } = storedUserInfo?.user_permissions?.add_ons || {};

    //     const tabsPermissions = [
    //         {name: "Active Messages", key: ""},
    //         {name: "Expired Messages", key: ""}
    //     ]

    // },[selectedTab])

    const handleTabChange = (index) => {
        setSelectedTab(index);
    };

    return (
        <div style={styles.mainContent}>
            <div className='title-container' style={{ paddingBottom: 10 }}>
                <h2 className='title'>To Do List</h2>
            </div>

            <div >
                <Tabs tabs={['Active', 'Completed/Not Completed/Expired']}
                selectedIndex={selectedTab}
                onTabChange={handleTabChange}>
                    {/* <NoticeBoardActiveMsgList currentTasks={currentTasks} currentPage={currentPage}  totalPages={totalPages}  handlePageChange={handlePageChange}/> */}
                    <ToDoListActiveItems activeToDoList={activeToDoList} activeToDoError={activeToDoError} activeToDoLoading={activeToDoLoading} onRefresh={fetchActiveToDoItemsList} setActiveToDoLoading={setActiveToDoLoading} setActiveToDoError={setActiveToDoError} setActiveToDoList={setActiveToDoList}/>
                    <ToDoListCompletedItems completedToDoList={completedToDoList} completedToDoError={completedToDoError} completedToDoLoading={completedToDoLoading} onRefresh={fetchExpiredToDoItemsList} setCompletedToDoLoading={setCompletedToDoLoading} setCompletedToDoError={setCompletedToDoError} setCompletedToDoList={setCompletedToDoList} fetchActiveToDoItemsList={fetchActiveToDoItemsList}/>
                </Tabs>
            </div>

        </div>


    )

};

const styles = {
    mainContent: {
        width: '95%',
        margin: 'auto'
    }

}

export default ToDoListScreen;